import { Component, OnChanges, OnInit, Input, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Money } from '../../../core/model/money';
import { LeaseAgreementCategory, LeaseAgreementCategoryToString } from '../../../rent/model/const/enums';
import { PieChartComponentBase } from '../base/pie-chart.base';

@Component({
    selector: 'app-category-invoice-amount',
    templateUrl: './category-invoice-amount.component.html',
    styleUrls: ['./category-invoice-amount.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CategoryInvoiceAmountComponent extends PieChartComponentBase implements OnChanges, OnInit {
  constructor() {
    super();
  }

  @Input() amount: Money;
  @Input() category: LeaseAgreementCategory;
  @Input() totalAmount: Money;

  categoryIcon: any;
  get title(): string {
    return LeaseAgreementCategoryToString(this.category);
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.updatePie([this.amount.amount, this.totalAmount.amount - this.amount.amount]);
  }

  ngOnChanges(changes: SimpleChanges) {
    let values = [];
    if (changes['amount'] && this.totalAmount) {
      values.push(changes['amount'].currentValue.amount, this.totalAmount.amount - changes['amount'].currentValue);
    } else if (changes['totalAmount'] && this.amount) {
      values.push(this.amount, changes['totalAmount'].currentValue.amount - this.amount.amount);
    }
    if (values) this.updatePie(values);
  }

  ngOnInit() {
    this.categoryIcon = {
      'house-user': this.category === LeaseAgreementCategory.Dwelling || this.category === LeaseAgreementCategory.CooperativeHousing,
      'house-blank': this.category === LeaseAgreementCategory.Other || this.category === LeaseAgreementCategory.Block,
      car: this.category === LeaseAgreementCategory.Parking,
      store: this.category === LeaseAgreementCategory.Premises,
    };
    this.colors = ['#2BA498', '#F4A909'];
  }
}
